module.exports = __webpack_public_path__ + "media/spring_tip_1-4dd94290f3e13cd37d73651cf326337b.mp3";